import { Label } from "@radix-ui/react-label";
import { useOutletContext } from "react-router-dom";

import { CopyToClipboardButton } from "@/components/CopyToClipboardButton";
import { GameEditDialog } from "@/components/dialogs/GameEditDialog";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { GameT } from "./queries";

export default function GameRoute() {
    const { game } = useOutletContext<{ game: GameT }>();

    return (
        <Card className="bg-brand-white text-brand-black m-4 rounded border-none">
            <CardHeader>
                <CardTitle>
                    {game.whitePlayer.nickname} vs. {game.blackPlayer.nickname}
                </CardTitle>
                <div className="flex items-start justify-between">
                    <div className="flex flex-col">
                        <div className="flex-row items-center">
                            <Label className="text-sm font-medium">ID: </Label>
                            <>
                                {game.id}
                                <CopyToClipboardButton text={game.id} />
                            </>
                        </div>
                    </div>
                    <GameEditDialog />
                </div>
            </CardHeader>
            <CardContent>
                <div className={"flex flex-col gap-4"}>
                    <div>
                        <Label className="text-md font-medium">White player</Label>
                        <p className="text-md text-muted-foreground">
                            {game.whitePlayer.name || "—"}
                        </p>
                    </div>
                    <div>
                        <Label className="text-md font-medium">Black player</Label>
                        <p className="text-md text-muted-foreground">
                            {game.blackPlayer.name || "—"}
                        </p>
                    </div>
                    <div>
                        <Label className="text-md font-medium">Scheduled start At</Label>
                        <p className="text-md text-muted-foreground">
                            {game.scheduledStartAt || "—"}
                        </p>
                    </div>
                    <div>
                        <Label className="text-md font-medium">Start At</Label>
                        <p className="text-md text-muted-foreground">{game.startedAt || "—"}</p>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
